import sectionsOperations from "fantastic/lib/sections";

const dispatchSelectedNode = (dispatch, id) => {
  dispatch({ type: "SELECTED_NODE/SET", payload: id });
  dispatch({ type: "SECTIONS/NODE/SELECTED", payload: { id, selected: true } });
};

export default id => (dispatch, getState) => {
  dispatchSelectedNode(dispatch, id);
};
